import { useCanDoLevelWrites } from "../entities/helpers/authorization";

export function useCanCreateNewUser() {
  return useCanDoLevelWrites(3);
}
